import React, { memo } from 'react';

import { Paper, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { formatActivityDateTime } from '../../Activities.utils';

const defaultObject = {};

const CommonActivityItem = ({ activity = defaultObject }) => {
  const { title, activityDateTime } = activity;

  const dateTime = formatActivityDateTime(activityDateTime);

  return (
    <Paper className="flex justify-between items-center shadow-none px-20 py-12 rounded-12 mb-8">
      <div className="flex items-center">
        <InfoIcon className="mr-20" size={36} />
        <Typography color="inherit" variant="medium16">
          Update: {title}
        </Typography>
      </div>
      <Typography color="inherit" variant="regular16">
        {dateTime}
      </Typography>
    </Paper>
  );
};

CommonActivityItem.propTypes = {
  activity: PropTypes.object,
};

export default memo(CommonActivityItem);
